import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {Review} from '@findhotel/sapi'

import {Card} from '@vio/atlas/Card'
import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {cssTheme} from '@vio/atlas/themes'
import {getLengthOfStay} from '@vio/core/src/utils/date'
import {ReviewSource} from '@vio/shared/src/search/ReviewComment'

import {ReviewCommentWrapper} from '../ReviewCommentWrapper'

interface Props {
  review: Review
  hasTranslationButton: boolean
  onReadMoreClick?: () => void
  translatedReviews?: Record<string, string>
}

const StyledButton = styled(NoStyleButton)`
  text-align: left;
  display: block;
  width: 100%;
`

const ReviewContainer = styled.div`
  padding: ${cssTheme.layout.spacing.s500};
  height: 183px;
  &.--carousel-card-wrapper {
    height: 220px;
  }
`

export const ReviewCarouselCard = ({
  review,
  hasTranslationButton,
  onReadMoreClick,
  translatedReviews = {}
}: Props) => {
  const {
    reviewerScore,
    reviewerName,
    reviewDate,
    checkIn,
    checkOut,
    reviewSource,
    text,
    language,
    id
  } = review
  const lengthOfStay = checkIn && checkOut && getLengthOfStay(checkIn, checkOut)

  return (
    <StyledButton onClick={onReadMoreClick}>
      <Card borderRadius="lg" borderColorPath="border.neutral.secondary">
        <ReviewContainer
          className={cx(hasTranslationButton && '--carousel-card-wrapper')}
        >
          <ReviewCommentWrapper
            disableReadMore
            reviewLanguage={language}
            reviewText={text}
            reviewerScore={reviewerScore}
            reviewerName={reviewerName}
            reviewDate={reviewDate}
            SourceLogoSlot={
              reviewSource && <ReviewSource providerCode={reviewSource} />
            }
            reviewSource={reviewSource}
            {...(lengthOfStay && {lengthOfStay})}
            truncatedContentLines={3}
            translatedReviewText={translatedReviews?.[id]}
          />
        </ReviewContainer>
      </Card>
    </StyledButton>
  )
}
